function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#72246C",
  d: "m 20.153,4 h -16 c -1.11,0 -1.99,0.89 -1.99,2 l -0.01,12 c 0,1.11 0.89,2 2,2 h 16 c 1.11,0 2,-0.89 2,-2 V 6 c 0,-1.11 -0.89,-2 -2,-2 z m 0,14 h -16 v -6 h 16 z m 0,-10 h -16 V 6 h 16 z"
});
const SvgIcPayment = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPayment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-payment.f40e06a7.svg";
export { ForwardRef as ReactComponent };